export default __webpack_public_path__ + "static/media/school_design_pants.f55b491e.png";